<section class="user-profile-about-subpage profile-section"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()">
  <section class="section" rel="about" *ngIf="about">
    <app-title [title]="isTeacher() ? (isMe ? 'user-profile.title-about-me' : 'user-profile.tab-about-tutor') : 'user-profile.title-about'">
      <ng-container *ngIf="about && isAuthor()" side>
        <span class="title-link"
              (click)="goEditProfile('/profile/about')">
          {{ 'user-profile.edit' | translate }}
        </span>
      </ng-container>
    </app-title>
    <p *ngIf="about; else noProfileAbout" class="description" [innerHTML]="about | striptags | nl2br"></p>
    <ng-template #noProfileAbout>
      <ng-template [ngIf]="isAuthor() && !loading">
        <app-empty [empty]="emptyAboutObj"></app-empty>
      </ng-template>
    </ng-template>
    <ng-container *ngIf="isMediaPrepared && !limited">
      <ng-container *ngIf="isVideoFromYoutube; else recordedVideo">
        <iframe [src]="safeMediaUrl"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="video">
        </iframe>
      </ng-container>
      <ng-template #recordedVideo>
        <video class="video" controls playsinline height="100%" width="100%">
          <source [src]="safeMediaUrl" type='video/mp4'>
        </video>
      </ng-template>
    </ng-container>
  </section>

  <ng-container *ngIf="isTeacher() && !limited">
    <section class="section" rel="education">
      <app-title [title]="'user-profile.title-education'">
        <ng-container side>
        <span *ngIf="isMe && educationSchools.length > 0"
              class="title-link"
              (click)="goEditProfile('/profile/education')">
          {{ 'user-profile.edit' | translate }}
        </span>
        </ng-container>
      </app-title>
      <ng-template [ngIf]="educationSchools.length" [ngIfElse]="noEducation">
        <div class="education">
          <div *ngFor="let item of educationSchools; trackBy: trackByFn" class="section-item">
            <div class="text-block">
              <span class="text label">{{ item.school_name || item.schoolName}}</span>
              <span class="text">{{ item.department_name || item.departmentName }}</span>
            </div>
            <span class="year">{{ item.end_year || item.endYear }}</span>
          </div>
        </div>
      </ng-template>
      <ng-template #noEducation>
        <ng-template [ngIf]="isAuthor() && !loading">
          <app-empty [empty]="emptyEducationObj"></app-empty>
        </ng-template>
      </ng-template>
    </section>

    <section class="section" rel="experience" *ngIf="workExperience!==null">
      <app-title [title]="'user-profile.title-experience'">
        <ng-container *ngIf="workExperience?.length && isAuthor()" side>
        <span class="title-link"
              (click)="goEditProfile('/profile/experience')">
          {{ 'user-profile.edit' | translate }}
        </span>
        </ng-container>
      </app-title>
      <ng-container *ngIf="!loading">
        <ng-template [ngIf]="workExperience?.length" [ngIfElse]="noExperience">
          <div class="experience">
            <div *ngFor="let workItem of workExperience" class="section-item">
              <div class="text-block">
                <span class="text label">{{ workItem.organization }}</span>
                <span class="text">{{ workItem.position }}</span>
              </div>
              <div class="work-years">
                <span class="year">{{ workItem.begin_year || workItem.beginYear }}</span>
                <span class="year"> &mdash; </span>
                <span class="year">
            {{ +(workItem.end_year || workItem.endYear) === 3000 ? ('profile-form.experience.until-now' | translate) : (workItem.end_year || workItem.endYear) }}
              </span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #noExperience>
        <ng-template [ngIf]="isAuthor() && !loading">
          <app-empty [empty]="emptyExperienceObj"></app-empty>
        </ng-template>
      </ng-template>
    </section>

    <section class="section" rel="certificates" *ngIf="certificates?.length">
      <app-title [title]="'profile-form.education.certificates'">
        <ng-container *ngIf="workExperience?.length && isAuthor()" side>
        <span class="title-link"
              (click)="goEditProfile('/profile/education')">
          {{ 'user-profile.edit' | translate }}
        </span>
        </ng-container>
      </app-title>
        <div class="certificate-wrap">
          <div *ngFor="let item of certificates; let idx = index"
               (click)="openCertificateModal(item, idx)"
               class="certificate-img-wrap">
            <on-ui-cover [cover]="getCertificateCover(item)" [withBlur]="true"></on-ui-cover>
          </div>
        </div>
    </section>

  </ng-container>

  <ng-template [ngIf]="certificateModalOpen">
    <app-modal *ngIf="!deviceService.isMobile()"
               [nopadding]="true"
               [prevNext]="true"
               [reachedPrev]="reachedPrev"
               [reachedNext]="reachedNext"
               (togglePrev)="togglePrev()"
               (toggleNext)="toggleNext()"
               (closed)="certificateModalOpen = false">
      <app-modal-body>
        <div class="certificate-cover">
          <img [src]="getCertificateCover(certificates[indexCertificate])?.img" alt="certificate-cover"/>
        </div>
      </app-modal-body>
    </app-modal>

    <app-mobile-modal *ngIf="deviceService.isMobile()" (closed)="certificateModalOpen = false">
      <app-mobile-modal-body>
        <div class="certificate-cover">
          <img [src]="getCertificateCover(certificates[indexCertificate])?.img" alt="certificate-cover"/>
        </div>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</section>
